import appGlobalScript from '/home/vsts/work/1/s/core/src/components/core/global/ads-global.ts';
export const globalScripts = appGlobalScript;
